import viewEditTabs from 'scoreboard/components/view-edit-tabs.hbs'

// initiatives
import initiativesTabs from 'scoreboard/initiatives/initiatives-tabs.hbs'

// scorecards
import scorecardsTabs from 'scoreboard/scorecards/scorecards-tabs.hbs'

// strategy maps
import strategyMapsTabs from '../strategy-maps/strategy-maps-tabs-template'

// dashboards
import dashboardsTabs from '../dashboards/display/dashboards-tabs-template'

// datasets
import datasetsTabs from 'scoreboard/datasets/datasets-tabs.hbs'

/**
 * File used to supplement metadata-objects.js and prevent circular dependencies
 * by supplying information about each object's tabs in a separate module
 * @type {{
 * bookmarks: {tabs: {}}, reports: {tabs: {}}, charts: {tabs: {}},
 * briefings: {tabs: {}}, scorecards: {tabs: {}}, initiatives: {tabs: {}},
 * files: {tabs: {}}, datasets: {tabs: {}}
 * }}
 */
var tabs = {
	scorecards: {
		tabs: scorecardsTabs
	},

	strategyMaps: {
		tabs: strategyMapsTabs
	},

	charts: {
		tabs: viewEditTabs
	},

	dashboards: {
		tabs: dashboardsTabs
	},

	initiatives: {
		tabs: initiativesTabs
	},

	briefings: {
		tabs: viewEditTabs
	},

	files: {
		tabs: viewEditTabs
	},

	reports: {
		tabs: viewEditTabs
	},

	bookmarks: {
		tabs: viewEditTabs
	},

	datasets: {
		tabs: datasetsTabs
	},

	forms: {
		tabs: viewEditTabs
	}
}

export default tabs
tabs.__filename__ = 'components/tabs.js'
